import { render, staticRenderFns } from "./formatkgraduate.vue?vue&type=template&id=77da5edc&scoped=true&"
import script from "./formatkgraduate.vue?vue&type=script&lang=js&"
export * from "./formatkgraduate.vue?vue&type=script&lang=js&"
import style0 from "./formatkgraduate.vue?vue&type=style&index=0&id=77da5edc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77da5edc",
  null
  
)

export default component.exports